class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('[data-cart-drawer-dialog]');
    this.content = this.querySelector('[data-cart-drawer-content]');
    this.closeButtons = this.querySelectorAll('[data-cart-drawer-close]');

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });

    this.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) this.onQuantityChange(quantityButton);
    });

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'product-form') return;
      if (event.cartData?.sections) this.updateContent(event.cartData.sections);
      this.open();
    });
  }

  open() {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
  }

  close() {
    if (!this.dialog?.open) return;

    this.dialog.classList.add('cart-drawer__dialog--closing');
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.dialog.classList.remove('cart-drawer__dialog--closing');
      this.dialog.close();
    };
    this.dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 400);
  }

  onQuantityChange(button) {
    const item = button.closest('[data-cart-item]');
    if (!item) return;

    const key = item.dataset.lineItemKey;
    const valueEl = item.querySelector('[data-quantity-value]');
    const currentQuantity = parseInt(valueEl?.textContent ?? '0', 10);

    let newQuantity;
    if (button.dataset.quantityChange === 'remove') {
      newQuantity = 0;
    } else {
      newQuantity = currentQuantity + parseInt(button.dataset.quantityChange, 10);
      if (newQuantity < 1) return;
    }

    this.updateItem(key, newQuantity, item);
  }

  updateItem(key, quantity, itemEl) {
    itemEl?.classList.add('cart-item--loading');
    itemEl?.querySelectorAll('button').forEach((button) => {
      button.disabled = true;
    });

    fetch(this.dataset.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity,
        sections: ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.sections) {
          this.updateContent(data.sections);
          CartDrawer.updateSections(data.sections);
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: data });
      })
      .catch((error) => {
        console.error(error);
        itemEl?.classList.remove('cart-item--loading');
        itemEl?.querySelectorAll('button').forEach((button) => {
          button.disabled = false;
        });
      });
  }

  updateContent(sections) {
    const html = sections['cart-drawer'];
    if (!html || !this.content) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsed.querySelector('[data-cart-drawer-content]');
    if (newContent) this.content.innerHTML = newContent.innerHTML;
  }

  static updateSections(sections) {
    Object.entries(sections).forEach(([sectionId, html]) => {
      if (sectionId === 'cart-drawer') return;

      const targets = document.querySelectorAll(`[data-section-updates="${sectionId}"]`);
      if (!targets.length) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newContent = parsed.querySelector('.shopify-section');
      if (!newContent) return;

      targets.forEach((target) => {
        target.innerHTML = newContent.innerHTML;
      });
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
